import { ResultOf } from "@graphql-typed-document-node/core";
import { useMemo } from "react";
import { CombinedError, useQuery } from "urql";

import { getFragmentData, graphql } from "@/gen";

const useTournamentStage_TournamentStage = graphql(`
    fragment useTournamentStage_TournamentStage on TournamentStage {
        __typename
        id
        title
        kind
        order
        description
        trialFormat
        tieBreakers
        eliminationSettings
        rounds {
            id
            ...RoundTable_Round
        }
    }
`);

export const TournamentStageQuery = graphql(`
    query tournamentStageQuery($id: UUID!) {
        tournamentStage(id: $id) {
            __typename
            id
            title
            rounds {
                id
                ...RoundTable_Round
            }
            ...useTournamentStage_TournamentStage
        }
    }
`);

export type TournamentStageT = ResultOf<typeof useTournamentStage_TournamentStage>;

export const useTournamentStage: (tournamentStageId?: string) => {
    tournamentStage: TournamentStageT | null | undefined;
    loading: boolean;
    error: CombinedError | undefined;
    refetch: () => void;
} = (tournamentStageId?: string) => {
    const [result, refetch] = useQuery({
        query: TournamentStageQuery,
        variables: {
            id: tournamentStageId!,
        },
        pause: !tournamentStageId,
    });

    const tournamentStage = useMemo(
        () => getFragmentData(useTournamentStage_TournamentStage, result.data?.tournamentStage),
        [result.data]
    );

    return {
        tournamentStage,
        loading: result.fetching,
        error: result.error,
        refetch,
    };
};

export const SetAllRoundsAndGamesScheduledStartAtMutation = graphql(`
    mutation SetAllRoundsAndGamesScheduledStartAt(
        $tournamentStageId: UUID!
        $scheduledStartAt: DateTime!
        $startRound: Int
    ) {
        setAllRoundsAndGamesScheduledStartAt(
            tournamentStageId: $tournamentStageId
            scheduledStartAt: $scheduledStartAt
            startRound: $startRound
        )
    }
`);

export const BulkCreateRoundsMutation = graphql(`
    mutation BulkCreateRounds(
        $tournamentStageId: UUID!
        $startTime: DateTime!
        $numberOfRounds: Int!
    ) {
        bulkCreateRounds(
            tournamentStageId: $tournamentStageId
            startTime: $startTime
            numberOfRounds: $numberOfRounds
        )
    }
`);
